module.exports = __webpack_public_path__ + "img/1-old.24d30ee1.png";